import { getColumnsByNames } from './all-top10-columns-config';

export const topTalkersColumns = getColumnsByNames([
    { name: 'src' },
    { name: 'dst'},
    { name: 'sessions', width: '53%' }
]);